import React, { Component, Fragment } from "react";

import MentionSelectionKeyboardOps from "./MentionSelectionKeyboardOps";
import MentionTypeaheadState from "./MentionTypeaheadState";
import MentionsPortal from "./MentionsPortal";
import PropTypes from "prop-types";
import SelectedSuggestionIndex from "./SelectedSuggestionIndex";
import { composeEventHandlers } from "../utils";
import insertMentionEntity from "./insertMentionEntity";
import { withoutAt } from "./utils";

export default class InlineMentions extends Component {
  static propTypes = {
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
  };

  state = {
    offeredSuggestions: [],
  };

  /**
   * @param   {EditorState} editorState
   * @param   {String}      mentionQuery
   * @returns {SelectionState}
   */
  projectMentionSelection = (editorState, mentionQuery) => {
    const originalContent = editorState.getCurrentContent();
    const selectionAfter = originalContent.getSelectionAfter();

    return selectionAfter.set("anchorOffset", selectionAfter.getFocusOffset() - mentionQuery.length);
  };

  /**
   * @param {MentionSuggestion} mentionSuggestion
   * @param {String}            mentionQuery
   */
  acceptSuggestion = (mentionSuggestion, mentionQuery) => {
    const { editorState, onChange } = this.props;

    const editorMention = mentionSuggestion.getEditorMention();

    const nextState = insertMentionEntity(
      editorState,
      this.projectMentionSelection(editorState, mentionQuery),
      editorMention.getDisplayText(),
      editorMention,
      editorMention.getMutability(),
    );

    onChange(nextState);
  };

  handleAcceptSuggestionAtIndex = (acceptingSuggestionIndex, mentionQuery) => (event) => {
    const { offeredSuggestions } = this.state;

    if (acceptingSuggestionIndex !== -1 && offeredSuggestions[acceptingSuggestionIndex]) {
      event.preventDefault();

      this.acceptSuggestion(offeredSuggestions[acceptingSuggestionIndex], mentionQuery);

      return true;
    }

    return false;
  };

  handleAcceptSuggestion = (mentionSuggestion, mentionQuery) => {
    this.acceptSuggestion(mentionSuggestion, mentionQuery);
    return true;
  };

  handleOfferSuggestions = (nextSuggestions) =>
    this.setState({
      offeredSuggestions: nextSuggestions,
    });

  handleResetState = () =>
    this.setState({
      offeredSuggestions: [],
    });

  handleContainerMouseDown = (event) => {
    event.preventDefault();
  };

  render() {
    const { editorState, children } = this.props;
    const { offeredSuggestions } = this.state;

    return (
      <MentionTypeaheadState editorState={editorState}>
        {({ top, left, visible, mentionQuery, resetState }) =>
          visible ? (
            <MentionsPortal top={top} left={left}>
              <SelectedSuggestionIndex firstInitial={true} suggestionsCount={offeredSuggestions.length}>
                {({ selectedSuggestionIndex, moveToPreviousSuggestion, moveToNextSuggestion }) => (
                  <>
                    {offeredSuggestions.length > 0 && (
                      <MentionSelectionKeyboardOps
                        handleEscape={composeEventHandlers(this.handleResetState, resetState)}
                        handleMoveToNext={moveToNextSuggestion}
                        handleMoveToPrevious={moveToPreviousSuggestion}
                        handleAcceptSuggestion={this.handleAcceptSuggestionAtIndex(
                          selectedSuggestionIndex,
                          mentionQuery,
                        )}
                      />
                    )}

                    <div onMouseDown={this.handleContainerMouseDown}>
                      {children({
                        mentionQuery: withoutAt(mentionQuery),
                        offeredSuggestions,
                        acceptSuggestion: (suggestionBeingAccepted) =>
                          this.handleAcceptSuggestion(suggestionBeingAccepted, mentionQuery),
                        selectedSuggestionIndex,
                        offerSuggestions: this.handleOfferSuggestions,
                        resetState: this.handleResetState,
                        visible,
                      })}
                    </div>
                  </>
                )}
              </SelectedSuggestionIndex>
            </MentionsPortal>
          ) : null
        }
      </MentionTypeaheadState>
    );
  }
}
